import {
  WBBox,
  WBChip,
  WBFlex,
  WBImageCarousel,
  WBTypography,
} from "@apptractive/design-system-web";
import { Image } from "@apptractive/stm-shared";
import { useEffect, useState } from "react";
import { Product } from "../API";
import { Box } from "@mui/material";
import { getExpiry } from "../helpers/datetime";

const ProductDetail = ({ product }: { product: Product }) => {
  const [images, setImages] = useState<any[]>([]);

  useEffect(() => {
    if (product?.images?.length > 0) {
      setImages(
        product.images.map(({ identityId, key }: Image | any) => ({
          src: null,
          identityId,
          key,
        }))
      );
    }
  }, [product]);

  return (
    <WBFlex
      sx={{
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "row",
          lg: "row",
        },
      }}
    >
      <WBBox flex={1}>
        <WBImageCarousel images={images} mediaAspectRatio={4 / 3} />
      </WBBox>
      <WBBox
        flex={1}
        sx={{
          px: {
            md: 3,
            lg: 3,
          },
        }}
      >
        <WBTypography variant="h1" fontSize="2rem">
          {product?.title}
        </WBTypography>

        <Box>
          {product?.tags?.map((tag) => (
            <WBChip
              key={tag}
              label={tag}
              color="secondary"
              variant="filled"
              size="small"
              sx={{
                mr: 1,
                mb: 1,
                background: "linear-gradient(135deg, #63b4f6, #78E9D3)",
                color: "#2C4052",
              }}
            />
          ))}
        </Box>

        {product?.expiresAt && (
          <WBTypography variant="h4" mt={1} color="error">
            {getExpiry(product.expiresAt)}
          </WBTypography>
        )}

        <WBTypography whiteSpace="pre-line">
          {product?.description}
        </WBTypography>

        <Box mt={1}>
          {product?.locations?.map((tag) => (
            <WBChip
              key={tag}
              label={tag}
              color="primary"
              variant="filled"
              size="small"
              sx={{
                mr: 1,
                mb: 1,
                background: "linear-gradient(135deg, #63b4f6, #78E9D3)",
                color: "#2C4052",
              }}
            />
          ))}
        </Box>
      </WBBox>
    </WBFlex>
  );
};

export default ProductDetail;
